<template>
<div class="privacy">
    <v-card class="pa-10" flat tile>
        <v-card-title class="d-flex flex-column text-center">
            <v-img :src="require('../assets/img/logo-dark-md.png')" class="header-logo mb-10" contain />
            <h1>Politique de confidentialité</h1>
        </v-card-title>

        <v-card-text 
            v-html="content" 
            class="pa-10 my-10"
        />
    </v-card>
        
    <Footer />
</div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { html } from 'js-to-html'

export default {
    name: `Privacy`,
    components: {
        Footer
    },
    data() {
        return {
            content: html.div(
                { class: `container` },
                [
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Le but de cette politique`),
                        html.p(`Le but de cette politique de confidentialité est d'informer 
                        les utilisateurs de notre site des données personnelles que nous 
                        recueillerons ainsi que les informations suivantes, le cas échéant :`),
                        html.ul([
                            html.li(`Les données personnelles que nous recueillerons`),
                            html.li(`L’utilisation des données recueillies`),
                            html.li(`Qui a accès aux données recueillies`),
                            html.li(`Les droits des utilisateurs du site`),
                            html.li(`La politique de cookies du site`),
                            html.li(`Les données personnelles que nous recueillerons`),
                            html.li(`Les données personnelles que nous recueillerons`)
                        ]),
                        html.p(`Cette politique de confidentialité fonctionne parallèlement aux 
                        conditions générales d’utilisation de notre site.`),
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Lois applicables`),
                        html.p(`Cette politique est conforme aux lois énoncées dans la loi sur 
                        la protection des renseignements personnels et les documents électroniques 
                        (LPRPDE).`),
                        html.p(`Pour les résidents des pays de l’UE, le Règlement général sur la 
                        protection des données (RGDP) régit toutes les politiques de protection des 
                        données, quel que soit l’endroit où se trouve le site. La présente politique 
                        de confidentialité vise à se conformer au RGDP. S’il y a des incohérences 
                        entre la présente politique et le RGDP, le RGDP s’appliquera.`),
                        html.p(`Pour les résidents de l’État de Californie, cette politique de 
                        confidentialité vise à se conformer à la California Consumer Privacy Act 
                        (CCPA). S’il y a des incohérences entre ce document et la CCPA, la législation 
                        de l’État s’appliquera. Si nous constatons des incohérences, nous modifierons 
                        notre politique pour nous conformer à la loi pertinente.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Consentement`),
                        html.p(`Les utilisateurs conviennent qu’en utilisant notre site, ils consentent :`),
                        html.ol([
                            html.li(`aux conditions énoncées dans la présente politique de confidentialité`),
                            html.li(`la collecte, l’utilisation et la conservation des données énumérées 
                            dans la présente politique.`)
                        ])
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Données personnelles collectées sur notre site`),
                        html.h4(`Données collectées automatiquement`),
                        html.p(`Nous ne collectons aucune donnée automatiquement sur notre site.`),
                        html.h4(`Données recueillies de façon non automatique`),
                        html.p(`Nous pouvons également collecter les données suivantes lorsque vous effectuez 
                        certaines actions sur notre site:`),
                        html.ul([
                            html.li(`Prénom et nom`),
                            html.li(`Adresse courriel`),
                            html.li(`Contenu et sujet du message créé par l'utilisateur`),
                        ]),
                        html.p(`Ces données peuvent être recueillies au moyen des méthodes suivantes:`),
                        html.ul([
                            html.li(`Envoi de message via le formulaire de contact du site web`),
                        ]),
                        html.p(`Veuillez noter que nous ne collectons que les données qui nous aident à 
                        atteindre l’objectif énoncé dans cette politique de confidentialité. Nous ne 
                        recueillerons pas de données supplémentaires sans vous en informer au préalable.`),
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Utilisation les données personnelles`),
                        html.p(`Les données personnelles recueillies sur notre site seront utilisées 
                        uniquement aux fins précisées dans la présente politique ou indiquées sur les 
                        pages pertinentes de notre site. Nous n’utiliserons pas vos données au-delà de 
                        ce que nous divulguerons.`),
                        html.p(`Les données que nous recueillons lorsque l’utilisateur exécute certaines 
                        fonctions peuvent être utilisées aux fins suivantes:`),
                        html.ul([
                            html.li(`Communication`),
                        ]),
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Partage des données personnellesc collectées`),
                        html.h4(`Employés`),
                        html.p(`Nous pouvons divulguer à tout membre de notre organisation les données 
                        utilisateur dont il a raisonnablement besoin pour réaliser les objectifs énoncés 
                        dans la présente politique.`),
                        html.h4(`Tierces parties`),
                        html.p(`Nous pouvons partager les données utilisateur avec les tiers suivants :`),
                        html.ul([
                            html.li(`Google Analytics`)
                        ]),
                        html.p(`Les tiers ne seront pas en mesure d’accéder aux données des utilisateurs 
                        au-delà de ce qui est raisonnablement nécessaire pour atteindre l’objectif donné.`),
                        html.h4(`Autres divulgations`),
                        html.p(`Nous nous engageons à ne pas vendre ou partager vos données avec des tiers, 
                        sauf dans les cas suivants:`),
                        html.ul([
                            html.li(`si la loi l'exige`),
                            html.li(`si elle est requise pour toute procédure judiciaire`),
                            html.li(`pour prouver ou protéger nos droits légaux`),
                            html.li(`à des acheteurs ou des acheteurs potentiels de cette société dans le 
                            cas où nous cherchons à la vendre la société`),
                            html.li(`si elle est requise pour toute procédure judiciaire`),
                        ]),
                        html.p(`Si vous suivez des hyperliens de notre site vers un autre site, veuillez 
                        noter que nous ne sommes pas responsables et n’avons pas de contrôle sur leurs 
                        politiques et pratiques de confidentialité.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Période de conservation des données personnelles stockées`),
                        html.p(`Les données des utilisateurs seront conservées pour une durée de :`),
                        html.ul([
                            html.li(`Jusqu'à ce que le client présente une demande de suppression des 
                            communications échangées avec l'entreprise.`)
                        ]),
                        html.p(`Nous veillerons à ce que les utilisateurs soient avisés si leurs données 
                        sont conservées plus longtemps que cette durée.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Comment nous protégeons vos données personnelles`),
                        html.p(`Afin d'assurer la protection des informations et données fournies par 
                        les utilisateurs du site web, nous avons conçu celui-ci de manière à ce que:`),
                        html.ul([
                            html.li(`la consultation des données stockées ne soit pas possible à partir 
                            de celui-ci`),
                            html.li(`seuls les administrateurs du site puissent accéder aux données stockées`),
                            html.li(`seuls les administrateurs du site ne puissent accéder aux données que 
                            par un  via un interface distinct et sécurisé`),
                            html.li(`l'usage des données stockées ne serve qu'à l'exécution du script permettant 
                            l'envoi automatisé par courriel des données fournies par l'utilisateur via le 
                            formulaire de contact du site web`)
                        ]),
                        html.p(`Alors que nous prenons toutes les précautions raisonnables pour nous assurer 
                        que nos données d’utilisateur sont sécurisées et que les utilisateurs sont protégés, 
                        il reste toujours du risque de préjudice. L’Internet en sa totalité peut être, parfois, 
                        peu sûr et donc nous sommes incapables de garantir la sécurité des données des 
                        utilisateurs au-delà de ce qui est raisonnablement pratique.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Transferts internationaux de données`),
                        html.p(`Les données utilisateur peuvent être consultées, traitées ou collectées 
                        dans les pays suivants:`),
                        html.ul([
                            html.li(`États-Unis`)
                        ])
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Mineurs`),
                        html.p(`Pour les résidents de l’UE, le RGPD précise que les personnes de moins de 
                        15 ans sont considérées comme des mineurs aux fins de la collecte de données. Les mineurs 
                        doivent avoir le consentement d’un représentant légal pour que leurs données soient 
                        recueillies, traitées et utilisées.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Vos droits en tant qu’utilisateur`),
                        html.p(`En tant qu’utilisateur, vous avez le droit d’accéder à toutes vos données 
                        personnelles que nous avons collectées. En outre, vous avez le droit de mettre à 
                        jour ou de corriger toute donnée personnelle en notre possession à condition qu’elle 
                        soit acceptable en vertu de la loi.`),
                        html.p(`Vous pouvez choisir de supprimer ou de modifier votre consentement à la 
                        collecte et à l’utilisation des données en tout temps, pourvu qu’il soit légalement 
                        acceptable de le faire et que vous nous en ayez informé dans un délai raisonnable.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Comment modifier, supprimer ou contester les données recueillies`),
                        html.p(`Si vous souhaitez que vos renseignements soient supprimés ou modifiés d’une 
                        façon ou d’une autre, veuillez communiquer avec notre agent de protection de la vie 
                        privée ici:`),
                        html.ul([
                            html.li( process.env.VUE_APP_FOUNDER ),
                            html.li( process.env.VUE_APP_EMAIL )
                        ])
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Politique sur les cookies`),
                        html.p(`Un cookie est un petit fichier, stocké sur le disque dur d’un utilisateur 
                        par le site Web. Son but est de recueillir des données relatives aux habitudes de 
                        navigation de l’utilisateur.`),
                        html.p(`Nous utilisons les types de cookies suivants sur notre site:`),
                        html.ul([
                            html.li(`Cookies fonctionnels - Nous les utilisons pour mémoriser toutes les 
                            sélections que vous faites sur notre site afin qu’elles soient sauvegardées 
                            pour vos prochaines visites.`),
                            html.li(`iCookies analytiques - Cela nous permet d’améliorer la conception 
                            et la fonctionnalité de notre site en recueillant des données sur le contenu 
                            auquel vous accédez et sur lequel vous vous accrochez en utilisant notre site.`)
                        ]),
                        html.p(`Vous pouvez choisir d’être averti chaque fois qu’un cookie est transmis. 
                        Vous pouvez également choisir de désactiver les cookies entièrement dans votre 
                        navigateur Internet, mais cela peut diminuer la qualité de votre expérience d’utilisation.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Cookies tiers`),
                        html.p(`Nous pouvons utiliser des cookies tiers sur notre site pour atteindre les 
                        objectifs suivants:`),
                        html.ul([
                            html.li(`Améliorer l'expérience de consultation du site web par les utilisateurs.`)
                        ])
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Modifications`),
                        html.p(`Cette politique de confidentialité peut être modifiée à l’occasion afin de 
                        maintenir la conformité avec la loi et de tenir compte de tout changement à notre 
                        processus de collecte de données. Nous recommandons à nos utilisateurs de vérifier 
                        notre politique de temps à autre pour s’assurer qu’ils soient informés de toute mise 
                        à jour. Au besoin, nous pouvons informer les utilisateurs par courriel des changements 
                        apportés à cette politique.`)
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Contact`),
                        html.p(`Si vous avez des questions à nous poser, n’hésitez pas à communiquer avec 
                        nous en utilisant ce qui suit:`),
                        html.ul([
                            html.li(`${ process.env.VUE_APP_EMAIL }`)
                        ])
                    ]),
                    html.div( { class: [ `mb-5` ] },
                    [
                        html.h3(`Date d’entrée en vigueur `),
                        html.p(`le 6 octobre 2020`),
                    ]),
                ]
            ).toHtmlText({pretty:true})
        }
    },
}
</script>

<style scoped>
.header-logo {
    height: 75px;
}
</style>